<div class="page student-form-page">
  <nav class="breadcrumb" [attr.aria-label]="'COMMON.BREADCRUMB' | translate">
    <a [routerLink]="studentsLink" class="breadcrumb-link">{{ 'STUDENTS.TITLE' | translate }}</a>
    <mat-icon class="breadcrumb-separator">chevron_right</mat-icon>
    <a
      *ngIf="!isNew && studentId"
      class="breadcrumb-link"
      [routerLink]="profileLink"
    >{{ 'STUDENTS.PROFILE' | translate }}</a>
    <mat-icon class="breadcrumb-separator" *ngIf="!isNew && studentId">chevron_right</mat-icon>
    <span class="breadcrumb-current">
      {{ (isNew ? 'STUDENTS.ADD_TITLE' : 'STUDENTS.EDIT_TITLE') | translate }}
    </span>
  </nav>

  <div class="page-header">
    <div>
      <h1>{{ (isNew ? 'STUDENTS.ADD_TITLE' : 'STUDENTS.EDIT_TITLE') | translate }}</h1>
      <p class="page-subtitle">{{ 'STUDENTS.FORM_SUBTITLE' | translate }}</p>
    </div>
    <div class="page-actions">
      <button type="button" class="btn btn-secondary" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        {{ 'COMMON.BACK' | translate }}
      </button>
      <button type="button" class="btn btn-primary" *ngIf="canSave" (click)="submit()" [disabled]="saving || loading">
        <mat-icon>{{ saving ? 'hourglass_empty' : 'save' }}</mat-icon>
        {{ (saving ? 'COMMON.SAVING' : 'COMMON.SAVE') | translate }}
      </button>
    </div>
  </div>

  <div class="form-loading" *ngIf="loading">
    <span class="spinner" aria-hidden="true"></span>
    {{ 'COMMON.LOADING' | translate }}
  </div>

  <form class="student-form" [formGroup]="form" *ngIf="!loading" (ngSubmit)="submit()">
    <section class="form-hero settings-panel">
      <div class="form-avatar" aria-hidden="true">
        <img *ngIf="photoValue; else initialsAvatar" [src]="photoValue" alt="" />
        <ng-template #initialsAvatar>{{ previewInitials }}</ng-template>
      </div>
      <div class="form-hero-text">
        <h2>{{ previewName || ((isNew ? 'STUDENTS.ADD_TITLE' : 'STUDENTS.EDIT_TITLE') | translate) }}</h2>
        <p>{{ 'STUDENTS.FORM_SUBTITLE' | translate }}</p>
        <div class="photo-actions">
          <label class="btn btn-secondary btn-sm photo-upload">
            <mat-icon>photo_camera</mat-icon>
            {{ 'STUDENTS.PHOTO_UPLOAD' | translate }}
            <input type="file" accept="image/*" (change)="onPhotoSelected($event)" hidden />
          </label>
          <button type="button" class="btn btn-ghost btn-sm" *ngIf="photoValue" (click)="clearPhoto()">
            {{ 'STUDENTS.PHOTO_CLEAR' | translate }}
          </button>
        </div>
      </div>
    </section>

    <section class="settings-panel">
      <div class="panel-header">
        <div class="panel-icon" aria-hidden="true">
          <mat-icon>badge</mat-icon>
        </div>
        <div class="panel-header-text">
          <h2>{{ 'STUDENTS.SECTION_IDENTITY' | translate }}</h2>
          <p>{{ 'STUDENTS.SECTION_IDENTITY_HINT' | translate }}</p>
        </div>
      </div>
      <div class="form-grid">
        <div class="form-field">
          <label for="firstNameAr">{{ 'STUDENTS.FIRST_NAME_AR' | translate }}</label>
          <input id="firstNameAr" type="text" formControlName="firstNameAr" />
        </div>
        <div class="form-field">
          <label for="lastNameAr">{{ 'STUDENTS.LAST_NAME_AR' | translate }}</label>
          <input id="lastNameAr" type="text" formControlName="lastNameAr" />
        </div>
        <div class="form-field">
          <label for="firstNameEn">{{ 'STUDENTS.FIRST_NAME_EN' | translate }}</label>
          <input id="firstNameEn" type="text" formControlName="firstNameEn" />
        </div>
        <div class="form-field">
          <label for="lastNameEn">{{ 'STUDENTS.LAST_NAME_EN' | translate }}</label>
          <input id="lastNameEn" type="text" formControlName="lastNameEn" />
        </div>
        <div class="form-field">
          <label for="studentCode">{{ 'STUDENTS.CODE' | translate }}</label>
          <input id="studentCode" type="text" formControlName="studentCode" />
        </div>
        <div class="form-field form-field-qr" *ngIf="!isNew && qrDataUrl">
          <label>{{ 'STUDENTS.QR_CODE' | translate }}</label>
          <div class="qr-preview">
            <img [src]="qrDataUrl" [alt]="'STUDENTS.QR_CODE' | translate" />
            <code>{{ qrCode }}</code>
            <span class="field-hint">{{ 'STUDENTS.QR_CODE_HINT' | translate }}</span>
          </div>
        </div>
        <div class="form-field">
          <label for="nationalId">{{ 'STUDENTS.NATIONAL_ID' | translate }}</label>
          <input id="nationalId" type="text" formControlName="nationalId" />
        </div>
        <div class="form-field">
          <label for="dateOfBirth">{{ 'STUDENTS.DATE_OF_BIRTH' | translate }}</label>
          <input id="dateOfBirth" type="date" formControlName="dateOfBirth" />
        </div>
        <div class="form-field">
          <label for="enrollmentDate">{{ 'STUDENTS.ENROLLMENT_DATE' | translate }}</label>
          <input id="enrollmentDate" type="date" formControlName="enrollmentDate" />
        </div>
        <div class="form-field">
          <label>{{ 'STUDENTS.SEX' | translate }}</label>
          <app-searchable-select
            formControlName="sex"
            [options]="sexOptions"
            [placeholder]="noneLabel"
            [emptyLabel]="noneLabel"
            [searchPlaceholder]="searchPlaceholder"
          ></app-searchable-select>
        </div>
        <div class="form-field">
          <label>{{ 'STUDENTS.BLOOD_TYPE' | translate }}</label>
          <app-searchable-select
            formControlName="bloodType"
            [options]="bloodTypeOptions"
            [placeholder]="noneLabel"
            [emptyLabel]="noneLabel"
            [searchPlaceholder]="searchPlaceholder"
          ></app-searchable-select>
        </div>
        <div class="form-field">
          <label>{{ 'STUDENTS.STATUS' | translate }}</label>
          <app-searchable-select
            formControlName="status"
            [options]="statusOptions"
            [allowEmpty]="false"
            [searchPlaceholder]="searchPlaceholder"
          ></app-searchable-select>
        </div>
      </div>
    </section>

    <section class="settings-panel">
      <div class="panel-header">
        <div class="panel-icon" aria-hidden="true">
          <mat-icon>school</mat-icon>
        </div>
        <div class="panel-header-text">
          <h2>{{ 'STUDENTS.SECTION_SCHOOL' | translate }}</h2>
          <p>{{ 'STUDENTS.SECTION_SCHOOL_HINT' | translate }}</p>
        </div>
      </div>
      <div class="form-grid">
        <div class="form-field">
          <label>{{ 'STUDENTS.CLASS' | translate }} *</label>
          <app-searchable-select
            formControlName="class"
            [options]="classOptions"
            [placeholder]="noneLabel"
            [emptyLabel]="noneLabel"
            [searchPlaceholder]="searchPlaceholder"
          ></app-searchable-select>
        </div>
        <div class="form-field">
          <label>{{ 'STUDENTS.ACADEMIC_YEAR' | translate }}</label>
          <app-searchable-select
            formControlName="academicYear"
            [options]="academicYearOptions"
            [placeholder]="noneLabel"
            [emptyLabel]="noneLabel"
            [searchPlaceholder]="searchPlaceholder"
          ></app-searchable-select>
        </div>
        <div class="form-field">
          <div class="field-label-row">
            <label>{{ 'STUDENTS.NATIONALITY' | translate }}</label>
            <button type="button" class="btn btn-ghost btn-sm" (click)="openCreateLookup('nationality')">
              <mat-icon>add</mat-icon>
              {{ 'STUDENTS.CREATE_NATIONALITY' | translate }}
            </button>
          </div>
          <app-searchable-select
            formControlName="nationality"
            [options]="nationalityOptions"
            [placeholder]="noneLabel"
            [emptyLabel]="noneLabel"
            [searchPlaceholder]="searchPlaceholder"
          ></app-searchable-select>
        </div>
        <div class="form-field">
          <div class="field-label-row">
            <label>{{ 'STUDENTS.RELIGION' | translate }}</label>
            <button type="button" class="btn btn-ghost btn-sm" (click)="openCreateLookup('religion')">
              <mat-icon>add</mat-icon>
              {{ 'STUDENTS.CREATE_RELIGION' | translate }}
            </button>
          </div>
          <app-searchable-select
            formControlName="religion"
            [options]="religionOptions"
            [placeholder]="noneLabel"
            [emptyLabel]="noneLabel"
            [searchPlaceholder]="searchPlaceholder"
          ></app-searchable-select>
        </div>
        <div class="form-field">
          <label>{{ 'STUDENTS.BUS' | translate }}</label>
          <app-searchable-select
            formControlName="bus"
            [options]="busOptions"
            [placeholder]="noneLabel"
            [emptyLabel]="noneLabel"
            [searchPlaceholder]="searchPlaceholder"
          ></app-searchable-select>
        </div>
      </div>
    </section>

    <section class="settings-panel" formGroupName="address">
      <div class="panel-header">
        <div class="panel-icon" aria-hidden="true">
          <mat-icon>location_on</mat-icon>
        </div>
        <div class="panel-header-text">
          <h2>{{ 'STUDENTS.SECTION_ADDRESS' | translate }}</h2>
          <p>{{ 'STUDENTS.SECTION_ADDRESS_HINT' | translate }}</p>
        </div>
      </div>
      <div class="form-grid">
        <div class="form-field">
          <label>{{ 'STUDENTS.EMIRATE' | translate }}</label>
          <app-searchable-select
            formControlName="emirate"
            [options]="emirateOptions"
            [placeholder]="noneLabel"
            [emptyLabel]="noneLabel"
            [searchPlaceholder]="searchPlaceholder"
          ></app-searchable-select>
        </div>
        <div class="form-field">
          <label>{{ 'STUDENTS.AREA' | translate }}</label>
          <app-searchable-select
            formControlName="area"
            [options]="areaOptions"
            [placeholder]="noneLabel"
            [emptyLabel]="noneLabel"
            [searchPlaceholder]="searchPlaceholder"
          ></app-searchable-select>
        </div>
        <div class="form-field">
          <label for="line1">{{ 'STUDENTS.LINE1' | translate }}</label>
          <input id="line1" type="text" formControlName="line1" />
        </div>
        <div class="form-field">
          <label for="line2">{{ 'STUDENTS.LINE2' | translate }}</label>
          <input id="line2" type="text" formControlName="line2" />
        </div>
        <div class="form-field">
          <label for="building">{{ 'STUDENTS.BUILDING' | translate }}</label>
          <input id="building" type="text" formControlName="building" />
        </div>
        <div class="form-field">
          <label for="flat">{{ 'STUDENTS.FLAT' | translate }}</label>
          <input id="flat" type="text" formControlName="flat" />
        </div>
        <div class="form-field full-width">
          <label for="landmark">{{ 'STUDENTS.LANDMARK' | translate }}</label>
          <input id="landmark" type="text" formControlName="landmark" />
        </div>
      </div>

      <div class="map-block" formGroupName="coordinates">
        <div class="map-toolbar">
          <div>
            <h3>{{ 'STUDENTS.MAP_TITLE' | translate }}</h3>
            <p>{{ 'STUDENTS.MAP_HINT' | translate }}</p>
          </div>
          <div class="map-toolbar-actions">
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              (click)="useCurrentLocation()"
              [disabled]="locating"
            >
              <mat-icon>{{ locating ? 'hourglass_empty' : 'my_location' }}</mat-icon>
              {{ (locating ? 'STUDENTS.LOCATING' : 'STUDENTS.USE_MY_LOCATION') | translate }}
            </button>
            <button type="button" class="btn btn-ghost btn-sm" *ngIf="hasMapPin" (click)="clearMapPin()">
              {{ 'STUDENTS.CLEAR_PIN' | translate }}
            </button>
          </div>
        </div>

        <div class="map-shell" [class.map-scroll-active]="mapScrollZoomActive">
          <div #mapHost class="address-map" role="application" [attr.aria-label]="'STUDENTS.MAP_TITLE' | translate"></div>
          <div class="map-overlay-hint" *ngIf="mapReady && !hasMapPin && !mapScrollZoomActive">
            {{ 'STUDENTS.MAP_CLICK_HINT' | translate }}
          </div>
          <div class="map-overlay-hint map-scroll-hint" *ngIf="mapReady && !mapScrollZoomActive && hasMapPin">
            {{ 'STUDENTS.MAP_SCROLL_HINT' | translate }}
          </div>
        </div>
      </div>
    </section>

    <section class="settings-panel">
      <div class="panel-header">
        <div class="panel-icon" aria-hidden="true">
          <mat-icon>call</mat-icon>
        </div>
        <div class="panel-header-text">
          <h2>{{ 'STUDENTS.SECTION_PHONES' | translate }}</h2>
          <p>{{ 'STUDENTS.SECTION_CONTACTS_HINT' | translate }}</p>
        </div>
        <button type="button" class="btn btn-secondary btn-sm" (click)="addPhone()">
          <mat-icon>add</mat-icon>
          {{ 'STUDENTS.ADD_PHONE' | translate }}
        </button>
      </div>

      <div class="entry-list" *ngIf="phones.length; else noPhones">
        <div class="entry-row" *ngFor="let phone of phones.controls; let i = index" [formGroup]="$any(phone)">
          <span class="entry-index">{{ i + 1 }}</span>
          <div class="form-field">
            <label>{{ 'STUDENTS.PHONE' | translate }}</label>
            <input type="text" formControlName="value" />
          </div>
          <div class="form-field">
            <label>{{ 'STUDENTS.CONTACT_LABEL' | translate }}</label>
            <app-searchable-select
              formControlName="label"
              [options]="contactLabelOptions"
              [allowEmpty]="false"
              [searchPlaceholder]="searchPlaceholder"
            ></app-searchable-select>
          </div>
          <label class="checkbox-pill">
            <input type="checkbox" formControlName="isPrimary" />
            <span>{{ 'STUDENTS.PRIMARY' | translate }}</span>
          </label>
          <button type="button" class="btn btn-ghost btn-icon entry-remove" (click)="removePhone(i)" [attr.aria-label]="'COMMON.DELETE' | translate">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
      <ng-template #noPhones>
        <div class="entries-empty">
          <mat-icon>phone_disabled</mat-icon>
          <strong>{{ 'STUDENTS.NO_PHONES' | translate }}</strong>
          <button type="button" class="btn btn-secondary btn-sm" (click)="addPhone()">
            <mat-icon>add</mat-icon>
            {{ 'STUDENTS.ADD_PHONE' | translate }}
          </button>
        </div>
      </ng-template>
    </section>

    <section class="settings-panel">
      <div class="panel-header">
        <div class="panel-icon" aria-hidden="true">
          <mat-icon>mail</mat-icon>
        </div>
        <div class="panel-header-text">
          <h2>{{ 'STUDENTS.SECTION_EMAILS' | translate }}</h2>
          <p>{{ 'STUDENTS.SECTION_CONTACTS_HINT' | translate }}</p>
        </div>
        <button type="button" class="btn btn-secondary btn-sm" (click)="addEmail()">
          <mat-icon>add</mat-icon>
          {{ 'STUDENTS.ADD_EMAIL' | translate }}
        </button>
      </div>

      <div class="entry-list" *ngIf="emails.length; else noEmails">
        <div class="entry-row" *ngFor="let email of emails.controls; let i = index" [formGroup]="$any(email)">
          <span class="entry-index">{{ i + 1 }}</span>
          <div class="form-field">
            <label>{{ 'STUDENTS.EMAIL' | translate }}</label>
            <input type="email" formControlName="value" />
          </div>
          <div class="form-field">
            <label>{{ 'STUDENTS.CONTACT_LABEL' | translate }}</label>
            <app-searchable-select
              formControlName="label"
              [options]="contactLabelOptions"
              [allowEmpty]="false"
              [searchPlaceholder]="searchPlaceholder"
            ></app-searchable-select>
          </div>
          <label class="checkbox-pill">
            <input type="checkbox" formControlName="isPrimary" />
            <span>{{ 'STUDENTS.PRIMARY' | translate }}</span>
          </label>
          <button type="button" class="btn btn-ghost btn-icon entry-remove" (click)="removeEmail(i)" [attr.aria-label]="'COMMON.DELETE' | translate">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
      <ng-template #noEmails>
        <div class="entries-empty">
          <mat-icon>unsubscribe</mat-icon>
          <strong>{{ 'STUDENTS.NO_EMAILS' | translate }}</strong>
          <button type="button" class="btn btn-secondary btn-sm" (click)="addEmail()">
            <mat-icon>add</mat-icon>
            {{ 'STUDENTS.ADD_EMAIL' | translate }}
          </button>
        </div>
      </ng-template>
    </section>

    <section class="settings-panel">
      <div class="panel-header">
        <div class="panel-icon" aria-hidden="true">
          <mat-icon>family_restroom</mat-icon>
        </div>
        <div class="panel-header-text">
          <h2>{{ 'STUDENTS.SECTION_PARENTS' | translate }}</h2>
          <p>{{ 'STUDENTS.SECTION_PARENTS_HINT' | translate }}</p>
        </div>
        <div class="panel-header-actions">
          <button type="button" class="btn btn-secondary btn-sm" (click)="openCreateParent()">
            <mat-icon>person_add</mat-icon>
            {{ 'STUDENTS.CREATE_PARENT' | translate }}
          </button>
          <button type="button" class="btn btn-secondary btn-sm" (click)="addParentLink()">
            <mat-icon>link</mat-icon>
            {{ 'STUDENTS.ADD_PARENT' | translate }}
          </button>
        </div>
      </div>

      <div class="entry-list" *ngIf="parentLinks.length; else noParents">
        <div class="entry-row entry-row-parents" *ngFor="let link of parentLinks.controls; let i = index" [formGroup]="$any(link)">
          <span class="entry-index">{{ i + 1 }}</span>
          <div class="form-field">
            <label>{{ 'STUDENTS.SELECT_PARENT' | translate }}</label>
            <app-searchable-select
              formControlName="parent"
              [options]="parentOptions"
              [placeholder]="('STUDENTS.SELECT_PARENT' | translate)"
              [emptyLabel]="('STUDENTS.SELECT_PARENT' | translate)"
              [searchPlaceholder]="searchPlaceholder"
            ></app-searchable-select>
          </div>
          <div class="form-field">
            <label>{{ 'STUDENTS.PARENT_RELATION' | translate }}</label>
            <app-searchable-select
              formControlName="relation"
              [options]="relationOptions"
              [allowEmpty]="false"
              [searchPlaceholder]="searchPlaceholder"
            ></app-searchable-select>
          </div>
          <label class="checkbox-pill">
            <input type="checkbox" formControlName="isPrimaryEmergency" />
            <span>{{ 'STUDENTS.PRIMARY_EMERGENCY' | translate }}</span>
          </label>
          <button type="button" class="btn btn-ghost btn-icon entry-remove" (click)="removeParentLink(i)" [attr.aria-label]="'COMMON.DELETE' | translate">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
      <ng-template #noParents>
        <div class="entries-empty">
          <mat-icon>group_off</mat-icon>
          <strong>{{ 'STUDENTS.NO_PARENTS' | translate }}</strong>
          <div class="entries-empty-actions">
            <button type="button" class="btn btn-secondary btn-sm" (click)="openCreateParent()">
              <mat-icon>person_add</mat-icon>
              {{ 'STUDENTS.CREATE_PARENT' | translate }}
            </button>
            <button type="button" class="btn btn-secondary btn-sm" (click)="addParentLink()">
              <mat-icon>link</mat-icon>
              {{ 'STUDENTS.ADD_PARENT' | translate }}
            </button>
          </div>
        </div>
      </ng-template>
    </section>

    <div class="form-actions-bar">
      <div class="form-actions-message" *ngIf="isError" role="alert">
        <mat-icon>error_outline</mat-icon>
        <span>{{ errorMessage | translate }}</span>
      </div>
      <div class="form-actions-buttons">
        <button type="button" class="btn btn-secondary" (click)="goBack()">{{ 'COMMON.CANCEL' | translate }}</button>
        <button type="submit" class="btn btn-primary" *ngIf="canSave" [disabled]="saving">
          <mat-icon>{{ saving ? 'hourglass_empty' : 'save' }}</mat-icon>
          {{ (saving ? 'COMMON.SAVING' : 'COMMON.SAVE') | translate }}
        </button>
      </div>
    </div>
  </form>
</div>

<div class="modal-backdrop" *ngIf="showCreateParent">
  <div class="modal-panel" role="dialog" aria-modal="true">
    <div class="modal-header">
      <h3>{{ 'STUDENTS.CREATE_PARENT_TITLE' | translate }}</h3>
      <button type="button" class="btn btn-ghost btn-icon" (click)="closeCreateParent()" [attr.aria-label]="'COMMON.CANCEL' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <div class="alert alert-error" *ngIf="createParentError">{{ createParentError | translate }}</div>
      <form [formGroup]="newParentForm" class="create-parent-form">
        <div class="form-grid">
          <div class="form-field">
            <label>{{ 'STUDENTS.FIRST_NAME_AR' | translate }}</label>
            <input formControlName="firstNameAr" />
          </div>
          <div class="form-field">
            <label>{{ 'STUDENTS.LAST_NAME_AR' | translate }}</label>
            <input formControlName="lastNameAr" />
          </div>
          <div class="form-field">
            <label>{{ 'STUDENTS.FIRST_NAME_EN' | translate }}</label>
            <input formControlName="firstNameEn" />
          </div>
          <div class="form-field">
            <label>{{ 'STUDENTS.LAST_NAME_EN' | translate }}</label>
            <input formControlName="lastNameEn" />
          </div>
          <div class="form-field">
            <label>{{ 'STUDENTS.PHONE' | translate }}</label>
            <input formControlName="phone" />
          </div>
          <div class="form-field">
            <label>{{ 'STUDENTS.PARENT_RELATION' | translate }}</label>
            <app-searchable-select
              formControlName="relation"
              [options]="relationOptions"
              [allowEmpty]="false"
              [searchPlaceholder]="searchPlaceholder"
            ></app-searchable-select>
          </div>
        </div>
        <label class="checkbox-pill create-parent-emergency">
          <input type="checkbox" formControlName="isPrimaryEmergency" />
          <span>{{ 'STUDENTS.PRIMARY_EMERGENCY' | translate }}</span>
        </label>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeCreateParent()">{{ 'COMMON.CANCEL' | translate }}</button>
      <button type="button" class="btn btn-primary" (click)="createParentAndLink()" [disabled]="creatingParent">
        <mat-icon>{{ creatingParent ? 'hourglass_empty' : 'person_add' }}</mat-icon>
        {{ (creatingParent ? 'COMMON.SAVING' : 'STUDENTS.CREATE_PARENT') | translate }}
      </button>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="showCreateLookup">
  <div class="modal-panel" role="dialog" aria-modal="true">
    <div class="modal-header">
      <h3>{{ createLookupTitleKey | translate }}</h3>
      <button type="button" class="btn btn-ghost btn-icon" (click)="closeCreateLookup()" [attr.aria-label]="'COMMON.CANCEL' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <div class="alert alert-error" *ngIf="createLookupError">{{ createLookupError | translate }}</div>
      <form [formGroup]="newLookupForm" class="create-parent-form">
        <div class="form-grid">
          <div class="form-field">
            <label>{{ 'COMMON.NAME_AR' | translate }}</label>
            <input formControlName="nameAr" />
          </div>
          <div class="form-field">
            <label>{{ 'COMMON.NAME_EN' | translate }}</label>
            <input formControlName="nameEn" />
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeCreateLookup()">{{ 'COMMON.CANCEL' | translate }}</button>
      <button type="button" class="btn btn-primary" (click)="createLookupAndAssign()" [disabled]="creatingLookup">
        <mat-icon>{{ creatingLookup ? 'hourglass_empty' : 'add' }}</mat-icon>
        {{ (creatingLookup ? 'COMMON.SAVING' : createLookupSaveKey) | translate }}
      </button>
    </div>
  </div>
</div>
